/* @flow */
import Entity from 'lib/Entity';

class MessageSender extends Entity {
  getName(): string {
    return this.get('name');
  }

  // TODO does API actually return null or are our test fixtures off?
  getColor(): ?string {
    return this.get('color');
  }

  getUuid() {
    return this.get('uuid');
  }

  getInitials(): string {
    return this.get('initials');
  }

  getProfilePictureUrl(): ?string {
    return this.get('profile_picture_url');
  }
}

export default MessageSender;
